import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=a179cf1a&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=a179cf1a&lang=sass&scoped=true&"
import style1 from "./Card.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a179cf1a",
  null
  
)

export default component.exports